export const NO_REFUND_POLICY_VERSION = '2026-08-29-v1';
export const NO_REFUND_POLICY_TEXT = 'All sales are final. Hunar does not offer refunds. If an item arrives damaged or incorrect, contact us promptly with your order number and photos so the team can review the issue.';
